import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { HistoricoMensagemStruct } from '../../../../shared/services/structs/srv-notificacao/historico-mensagem.struct';

@Component({
  selector: 'app-notificacao-detalhe-modal',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule
  ],
  templateUrl: './notificacao-detalhe-modal.component.html',
  styleUrls: ['./notificacao-detalhe-modal.component.css']
})
export class NotificacaoDetalheModalComponent {

  constructor(
    public dialogRef: MatDialogRef<NotificacaoDetalheModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: HistoricoMensagemStruct
  ) {}

  fechar(): void {
    this.dialogRef.close();
  }
}